import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Typeahead } from 'react-bootstrap-typeahead';

type Props = {
  value: string,
  handleBlur: string,
  id: string,
  setFormikState: () => void,
  invalid: boolean,
};

function NationalityDropdown(props: Props) {
  const { setFormikState, countries, value, handleBlur, id, invalid } = props;

  function handleSelected(selected) {
    if (selected.length !== 0) {
      setFormikState(selected[0].iso_alpha_2);
    } else {
      setFormikState('');
    }
  }

  return (
    <div id={id}>
      <Typeahead
        placeholder="Select Nationality"
        onChange={handleSelected}
        options={!isEmpty(countries) ? countries : []}
        labelKey="name"
        onBlur={handleBlur}
        isInvalid={invalid}
        selected={
          !isEmpty(countries)
            ? countries.filter(country => country.iso_alpha_2 === value)
            : []
        }
      />
    </div>
  );
}

const mapStateToProps = ({ flights: { countries } }) => ({ countries });

export default connect(mapStateToProps)(NationalityDropdown);



// WEBPACK FOOTER //
// ./src/screens/Flights/PassengerDetails/NationalityDropdown.js